import ONavButtonsBlock from './o-nav-buttons-block';

export default ONavButtonsBlock;